export const isModalOpen = () => {
    return !!document.querySelector('.MuiModal-root');
};
